import type { LotteryEditPhase } from '@lotta/feature-lottery-rules';
import { createContext } from 'react';
import type { LotteryFormTemplate } from './types';

type ResultType = {
  isCreateLotteryLoading?: boolean;
  isUpdateLotteryLoading?: boolean;
};

type LotteryFormContextType = {
  mode: LotteryEditPhase;
  template?: LotteryFormTemplate;
  result?: ResultType;
};

export const LotteryFormContext = createContext<LotteryFormContextType>({
  mode: 'OPEN',
});

export const allowFieldInput = (
  requiredMode: LotteryEditPhase[],
  context: LotteryFormContextType
) => {
  return requiredMode.includes(context.mode);
};
